import React from 'react';
import { startCase } from 'lodash';

const PageErr = ({ err }) => (
  <div
    className="py-5 bg-secondary">
    <div
      className="m-auto mw-100"
      style={{ width: '700px' }}>
      {/* <img src="/assets/img/500-in.png" className="mw-100" /> */}
      <div className="text-center">
        <h2 className="display-5">
          {err.code} - {startCase(err.payload)}
        </h2>
      </div>
    </div>
  </div>
);

export default PageErr;
